import React from "react";
import { Search, X } from "lucide-react";

interface CityFiltersProps {
  search: string;
  onSearchChange: (search: string) => void;
  countryCode: string;
  onCountryCodeChange: (countryCode: string) => void;
}

export const CityFilters: React.FC<CityFiltersProps> = ({
  search,
  onSearchChange,
  countryCode,
  onCountryCodeChange,
}) => {
  const handleClearFilters = () => {
    onSearchChange("");
    onCountryCodeChange("");
  };

  const hasActiveFilters = search || countryCode;

  return (
    <div className="bg-white p-4 rounded-lg border border-gray-200 space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-medium text-gray-700">Filters</h3>
        {hasActiveFilters && (
          <button
            onClick={handleClearFilters}
            className="text-sm text-primary-600 hover:text-primary-700 flex items-center space-x-1"
          >
            <X className="w-4 h-4" />
            <span>Clear all</span>
          </button>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Search */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Search
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Search className="h-4 w-4 text-gray-400" />
            </div>
            <input
              type="text"
              value={search}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder="Search city ID or name..."
              className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-primary-500 focus:border-primary-500"
            />
          </div>
        </div>

        {/* Country Code */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Country Code
          </label>
          <input
            type="text"
            value={countryCode}
            onChange={(e) => onCountryCodeChange(e.target.value.toUpperCase())}
            placeholder="e.g., DK, US, UK"
            maxLength={2}
            className="block w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-primary-500 focus:border-primary-500 uppercase"
          />
        </div>
      </div>
    </div>
  );
};
